// extracted by mini-css-extract-plugin
export default {"instructions-wrapper":"styles_instructions-wrapper__i6OIY","text-area":"styles_text-area__RTacS","improve-icon":"styles_improve-icon__cHufl"};